module.exports = __webpack_public_path__ + "img/rentdeer_banner.52ed1b7c.png";